import gql from 'graphql-tag';

export const TAG_DETAILS_FRAGMENT = gql`
  fragment TagDetails on Tag {
    tagId
    organisationId
    userId
    label
    color
    tagType
    resourceType
    createdAt
    updatedAt
  }
`;